var _rect, _circle, _path, _circle2, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5714,
    cy: 49.5714,
    r: 28.5714,
    fill: "#C0EBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2041 61V71.6122C46.3265 84.2653 64.3537 75.8299 69.1837 69.3673V61C67.7143 55.449 60.8163 52.9728 57.551 52.4286H40C32.4898 52.5918 30.3401 58.2109 30.2041 61Z",
    fill: "#3C66D2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1453,
    cy: 43.8595,
    r: 10.88,
    fill: "#2F3A4C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.551,
    cy: 64.8775,
    r: 12.449,
    fill: "#8DCD35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9917 64.4389L64.7807 68.7979L73.7 61.204",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientApproval);
export default __webpack_public_path__ + "static/media/client_approval.422267b917c1cdf65fed30e31508e964.svg";
export { ForwardRef as ReactComponent };